import { PasswordResetEditForm } from '@/pages/PasswordResets/EditForm'

type SchoolPasswordResetEditProps = {
  token: string
}

export default function SchoolPasswordResetEdit({ token }: SchoolPasswordResetEditProps) {
  return (
    <PasswordResetEditForm
      title="高校コーチ パスワード再設定"
      token={token}
      patchPath="/school/password_resets/:token"
    />
  )
}
